const link = (
  <a href="https://vk.com/box107" target="_blank" rel="noreferrer">
    Виктории Голобородовой
  </a>
);
const link2 = (
  <a href="https://vk.com/happyjiva" target="_blank" rel="noreferrer">
    Марии Будяковой
  </a>
);
const link3 = (
  <a href="https://vk.com/irina.v.ilina" target="_blank" rel="noreferrer">
    Ирины Ильиной
  </a>
);
const fnsProfile = (
  <a href="https://www.rusprofile.ru/ip/320745600015783">
    Официальная регистрация в ФНС
  </a>
);

export const APP_BENEFITS = [
  {
    text: [
      "Лёгкость и удобство работы",
      "Наличие инструкций и обучающих материалов",
      "Компетентная техническая поддержка",
      "Индивидуальное отношение к каждому клиенту",
    ],
  },
  {
    text: [
      "Опыт работы с 2017 года",
      fnsProfile,
      "Оплата через онлайн-кассу без комиссии с чеком",
      "Оперативная обработка заказов",
    ],
  },
  {
    text: [
      "Ценность обратной связи",
      "Возможность участвовать в развитии приложения",
      "Партнёрская программа с авторами МАК и ведущими игр",
      "Скидки для постоянных клиентов на продление лицензии и покупку МАК и игр",
    ],
  },
  {
    text: [
      "Регулярные обновления приложения",
      "Исправление ошибок",
      "Оборудование размещено на территории Российской Федерации",
      "Технические решения от ведущих IT-компаний",
    ],
  },
  {
    text: [`Разработано при поддержке:`, link, link2, link3],
  },
];
